<template>
   <v-card flat>
    <v-card-title>GET - /api/postcodes/{postcode}/addresses/byfield</v-card-title>
    <hr />
    <v-card-text>
      <v-simple-table class="table">
        <template v-slot:default>
          <tbody>
            <tr>
              <td>HTTP Method :</td>
              <td>GET</td>
            </tr>
            <tr>
              <td>URL :</td>
              <td>
                <a :href="url + restUrl" target="_blank">{{url +restUrl}}</a>
              </td>
            </tr>
            <tr>
              <td>Description :</td>
              <td>
                This function allows you to get an address based on the postcode entered and fields. It gives the response based on the request parameters.
                <br />This function returns the list of addresses based on postcode value.
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-title>Request Parameters:</v-card-title>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Parameter Name</th>
              <th class="text-left">Description</th>
              <th class="text-left">Parameter Type</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>postcode</td>
              <td>Postcode value to get address</td>
              <td>path</td>
            </tr>
            <tr>
              <td>fields</td>
              <td>AddressId, postcode ,Address,Additional, misc.Any child node of above</td>
              <td>query</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-title>Postcode:</v-card-title>
    <v-card-text>
      <ul v-for="(postcodelist,i) in postcodeLists" :key="i">
        <li v-text="postcodelist.text"></li>
      </ul>
    </v-card-text>

    <v-card-title>Fields:</v-card-title>
    <v-card-text>
      <ul>
        <li>The top level fields values are AddressId, Postcode, Address, Additional, Misc.</li>
        <li>
          You can send fields values as a top level fields child node.  e.g.
        <br/><pre><code v-html="fieldAddressJson" /></pre><br/> You can send a “OrganisationName” as a fields value.</li>
         
        <li>fields parameter can accept a single value as well as multiple values separated by “,”</li>
      </ul>
    </v-card-text>

    <v-card-title>AddressId:</v-card-title>
    <v-card-text>
      <ul>
        <li>If fields value is AddressId then below output as a JSON Response.</li>
        <li>Other fields values (Address, Additional, Misc) are empty.</li>
      </ul>
    </v-card-text>

    <v-card-title>JSON Response:</v-card-title>
    <v-card-text>
      <pre>
      <code v-html="addressIDJson" />
      </pre>
    </v-card-text>

    <v-card-title>Postcode</v-card-title>
    <v-card-text>
      <ul>
        <li>If fields value is “postcode” then output is similar to above JSON response.</li>
        <li>Other fields values (Address, Additional, Misc) are empty.</li>
      </ul>
    </v-card-text>

    <v-card-title>Address</v-card-title>
    <v-card-text>
      <ul>
        <li>If fields value is “address” then below output as a JSON Response.</li>
        <li>Other fields values (Additional, Misc) are empty.</li>
      </ul>
    </v-card-text>

    <v-card-title>JSON Response:</v-card-title>
    <v-card-text>
      <pre>
      <code v-html="addressJson" />
      </pre>
    </v-card-text>

    <v-card-title>Additional</v-card-title>
    <v-card-text>
      <ul>
        <li>If fields value is “additional” then below output as a JSON Response.</li>
        <li>Other fields values (Address ,Misc ) are empty</li>
        <li>
          If fields value is additional then in JSON response one more field is getting added – Address Coordinates with Latitude and Longitude values.
         <pre>
          <code
            v-html="jsonAddressCoordinates"
          />
         </pre>
        </li>
      </ul>
    </v-card-text>

    <v-card-title>JSON Response:</v-card-title>
    <v-card-text>
      <pre>
      <code v-html="additionalJson" />
      </pre>
    </v-card-text>

    <v-card-title>Misc</v-card-title>
    <v-card-text>
      <ul>
        <li>If fields value is “misc” then below output as a JSON Response.</li>
        <li>Other fields values (Address,Additional) are empty.</li>
      </ul>
    </v-card-text>

    <v-card-title>JSON Response:</v-card-title>
    <v-card-text>
      <pre>
      <code v-html="miscJson" />
      </pre>
    </v-card-text>

    <v-card-title>Fields - AddressId, Postcode, Address, Additional, Misc</v-card-title>
    <v-card-text>
      <ul>
        <li>If fields value is “ AddressId, Postcode, Address, Additional, Misc” then below output as a JSON Response.</li>
      </ul>
    </v-card-text>

    <v-card-title>JSON Response:</v-card-title>
    <v-card-text>
      <pre>
      <code v-html="otherJson" />
      </pre>
    </v-card-text>
    <br/>
  </v-card>
</template>

<script>
export default {
  name: "byfield",
  
  data: () => ({
    url: process.env.VUE_APP_BASE_URL,
  restUrl: "postcodes/{postcode}/addresses/byfield",
    addressIDJson: [
      {
        AddressId: "32171910-b000-0000-0000-000003919038",
        Postcode: "RG1 8LS",
        Address: {},
        Additional: {},
        Misc: {}
      }
    ],
    addressJson: [
      {
        AddressId: "32171910-b000-0000-0000-000003919038",
        Postcode: "RG1 8LS",
        Address: {
          OrganisationName: "APPNOVATION TECHNOLOGIES LTD",
          DepartmentName: "",
          PoBoxNumber: "",
          SubBuilding: "",
          Building: "READING BRIDGE HOUSE",
          DependentThoroughfare: "",
          Thoroughfare: "READING BRIDGE",
          DoubleDependentLocality: "",
          DependentLocality: "",
          PostTown: "READING",
          Postcode: "RG1 8LS",
          County: "OXFORDSHIRE"
        },
        Additional: {},
        Misc: {}
      }
    ],
    fieldAddressJson: [
      {
       Address: {
          OrganisationName: "APPNOVATION TECHNOLOGIES LTD",
          DepartmentName: "",
          PoBoxNumber: "",
          SubBuilding: "",
          Building: "READING BRIDGE HOUSE",
          DependentThoroughfare: "",
          Thoroughfare: "READING BRIDGE",
          DoubleDependentLocality: "",
          DependentLocality: "",
          PostTown: "READING",
          Postcode: "RG1 8LS",
          County: "OXFORDSHIRE"
        }
      }
    ],
    miscJson: [
      {
        AddressId: "32171910-b000-0000-0000-000003919038",
        Postcode: "RG1 8LS",
        Address: {},
        Additional: {},
        Misc: {
          AddressStatus: "L",
          NumberHouseholds: "1",
          UDPRN: "54811439",
          Building_Number: "0",
          Building_Name: "READING BRIDGE HOUSE"
        }
      }
    ],
    additionalJson: [
      {
        AddressId: "32171910-b000-0000-0000-000003919038",
        Postcode: "RG1 8LS",
        Address: {},
        Additional: {
          postcode_outcode: "RG1",
          postcode_incode: "8LS",
          introduction_date: "1990/01",
          grid_east: "471800",
          grid_north: "173900",
          areacode_county: "E99999999",
          areacode_district: "E06000038",
          ward: "E05002319",
          user_type: "0",
          grid_status: "1",
          country: "E92000001",
          country_name: "England",
          nhs_code: "E18000009",
          nhs_region: "E19000002",
          ONS_Country_Code: "E92000001",
          ONS_Country_Name: "England",
          ONS_LA_UA_Code: "E06000038",
          ONS_LA_UA_Name: "Reading",
          ONS_Ward_Code: "E05002319",
          ONS_Ward_Name: "Abbey",
          ONS_SHA_Code: "E18000009",
          ONS_SHA_Name: "South Central"
        },
        Misc: {},
        AddressCoordinates: {
          Latitude: 51.45953219535399,
          Longitude: -0.9679312802802723
        }
      }
    ],
    jsonAddressCoordinates: [
      {
        AddressCoordinates: {
          Latitude: 51.45953219535399,
          Longitude: -0.9679312802802723
        }
      }
    ],
    otherJson: [
      {
        AddressId: "32171910-b000-0000-0000-000003919038",
        Postcode: "RG1 8LS",
        Address: {
          OrganisationName: "APPNOVATION TECHNOLOGIES LTD",
          DepartmentName: "",
          PoBoxNumber: "",
          SubBuilding: "",
          Building: "READING BRIDGE HOUSE",
          DependentThoroughfare: "",
          Thoroughfare: "READING BRIDGE",
          DoubleDependentLocality: "",
          DependentLocality: "",
          PostTown: "READING",
          Postcode: "RG1 8LS",
          County: "OXFORDSHIRE"
        },
        Additional: {
          postcode_outcode: "RG1",
          postcode_incode: "8LS",
          introduction_date: "1990/01",
          grid_east: "471800",
          grid_north: "173900",
          areacode_county: "E99999999",
          areacode_district: "E06000038",
          ward: "E05002319",
          user_type: "0",
          grid_status: "1",
          country: "E92000001",
          country_name: "England",
          nhs_code: "E18000009",
          nhs_region: "E19000002",
          ONS_Country_Code: "E92000001",
          ONS_Country_Name: "England",
          ONS_LA_UA_Code: "E06000038",
          ONS_LA_UA_Name: "Reading",
          ONS_Ward_Code: "E05002319",
          ONS_Ward_Name: "Abbey",
          ONS_SHA_Code: "E18000009",
          ONS_SHA_Name: "South Central"
        },
        Misc: {
          AddressStatus: "L",
          NumberHouseholds: "1",
          UDPRN: "54811439",
          Building_Number: "0",
          Building_Name: "READING BRIDGE HOUSE"
        },
        AddressCoordinates: {
          Latitude: 51.45953219535399,
          Longitude: -0.9679312802802723
        }
      }
    ],
    postcodeLists: [
      {
        text:
          "Postcode value is mandatory. Postcode should be valid otherwise its throws an error Postcode does not exist."
      },
      {
        text:
          "Postcode value can contain single (*) wildcard character.(E.g. RG1*Ls)"
      },
      {
        text:
          "Double wildcard character not allowed in postcode. (E.g. RG1**s , R*L1*s)"
      }
    ],
  })
};
</script>
